let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7RUPW")).then(() => parcelRequire('kZgkA'));